import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../service/axiosInterceptors";
import { apiRoute } from "../../../service/api";

export const getParentDashboardProgress = createAsyncThunk(
    "parentDashboard/getProgress",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.childProgressUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentDashboardUpcomingEvents = createAsyncThunk(
    "parentDashboard/getUpcomingEvents",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.childUpcomingEventUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentDashboardCurriculum = createAsyncThunk(
    "parentDashboard/getCurriculum",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.childCurriculumStatusUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentDashboardIncident = createAsyncThunk(
    "parentDashboard/getIncident",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.childIncidentUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentDashboardUnpaidInvoice = createAsyncThunk(
    "parentDashboard/getUnpaidInvoice",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.childUnpaidInvoiceUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentDashboardWeeklyAttendance = createAsyncThunk(
    "parentDashboard/getWeeklyAttendance",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.childWeeklyAttendanceUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentDashboardMealPlan = createAsyncThunk(
    "parentDashboard/getMealPlan",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.childMealPlanUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentDashboardNewsLetter = createAsyncThunk(
    "parentDashboard/getNewsLetter",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.childNewsLetterUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentTodayTimeline = createAsyncThunk(
    "parentDashboard/getTodayTimeline",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.todayChildActivityUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

export const getParentDashboardMessages = createAsyncThunk(
    "parentDashboard/getMessages",
    async (_, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(apiRoute.dashboardMessageUrl);
            return res.data;
        } catch (e) { return rejectWithValue(e.response?.data || e.message); }
    }
);

const parentDashboardSlice = createSlice({
    name: "parentDashboard",
    initialState: {
        isLoading: false,
        progress: null,
        upcomingEvents: [],
        curriculum: null,
        incident: null,
        unpaidInvoice: null,
        weeklyAttendance: null,
        mealPlan: [],
        newsLetter: [],
        todayTimeline: [],
        dashboardMessages: [],
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        const handle = (thunk, key) => {
            builder
                .addCase(thunk.pending, (state) => { state.isLoading = true; })
                .addCase(thunk.fulfilled, (state, action) => { state.isLoading = false; state[key] = action.payload?.data; })
                .addCase(thunk.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
        };
        handle(getParentDashboardProgress, "progress");
        handle(getParentDashboardUpcomingEvents, "upcomingEvents");
        handle(getParentDashboardCurriculum, "curriculum");
        handle(getParentDashboardIncident, "incident");
        handle(getParentDashboardUnpaidInvoice, "unpaidInvoice");
        handle(getParentDashboardWeeklyAttendance, "weeklyAttendance");
        handle(getParentDashboardMealPlan, "mealPlan");
        handle(getParentDashboardNewsLetter, "newsLetter");
        handle(getParentTodayTimeline, "todayTimeline");
        handle(getParentDashboardMessages, "dashboardMessages");
    }
});

export default parentDashboardSlice.reducer;
